import { FilterContext } from 'app/modules/filters/models';

const BASE = 'savedFilters';

export const SAVED_FILTERS_QUERY_KEYS = {
  list: (filterContext: FilterContext) =>
    [BASE, 'list', filterContext] as const,
} as const;
